import { useState, useEffect } from "react"
import { Flame, Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react"
import { serviceAPI } from "../services/serviceService"

function Footer() {
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await serviceAPI.getRandomFiveServices({ active: true })
        setServices(response)
      } catch (error) {
        console.error("Footer services fetch error:", error)
        // Fallback services if API fails
        setServices([
          "Doğal Gaz Tesisatı",
          "Su Tesisatı", 
          "Kombi Bakım Onarım",
          "Beyaz Eşya Servisi",
          "Klima Servisi"
        ])
      } finally {
        setLoading(false)
      }
    }

    fetchServices()
  }, [])

  const quickLinks = [
    { name: "Anasayfa", href: "/" },
    { name: "Hizmetler", href: "/hizmetler" },
    { name: "Hakkımızda", href: "/hakkimizda" },
    { name: "Referanslar / Projeler", href: "/projeler" },
    { name: "İletişim", href: "/iletisim" },
  ]

  const socialLinks = [
    { icon: Facebook, href: "https://www.facebook.com/ramazan.basol.35", name: "Facebook" },
    { icon: Instagram, href: "https://www.instagram.com/bugrateknikservis", name: "Instagram" },
  ]

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="/bts_logo_seffaf.png" 
                alt="BTS Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold">Buğra Teknik Servis</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
            Şirketimiz 2010 yılında Karabük İlinde Kuruldu… Profesyonel ve kendi dalında uzman arkadaşlarımızla Karabük ve İlçelerine sabah 09:00 gece 21:00 arası hizmet vermekteyiz.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Phone className="h-4 w-4" />
                <span>0533 428 70 27</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Mail className="h-4 w-4" />
                <span>ramazanbasol74@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <MapPin className="h-4 w-4" />
                <span>Şirinevler Mahalesi Bestekar Sokak No-20 Karabük/Merkez</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hızlı Menü</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hizmetlerimiz</h3>
            {loading ? (
              <div className="space-y-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="h-4 bg-gray-700 rounded animate-pulse"></div>
                ))}
              </div>
            ) : (
              <ul className="space-y-2">
                {services.map((service, index) => (
                  <li key={index}>
                    <a
                      href="/hizmetler"
                      className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-200"
                    >
                      {typeof service === 'string' ? service : service.title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Social Media & Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Bizi Takip Edin</h3>
            <div className="flex space-x-4 mb-6">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 hover:bg-blue-600 p-2 rounded-lg transition-colors duration-200"
                  aria-label={social.name}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
            <div className="space-y-2">
              <p className="text-sm text-gray-300 font-medium">Çalışma Saatleri:</p>
              <p className="text-sm text-gray-400">Her gün</p>
              <p className="text-sm text-gray-400">09:00 - 21:00</p>
              

            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">© {new Date().getFullYear()} Buğra Teknik Servis. Tüm hakları saklıdır.</p>
            <p className="text-sm text-gray-500">
            <span className="text-blue-400"><a href="https://www.uykatech.com" target="_blank">UykaTech</a> </span> tarafından yapıldı
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
